// VENDÔME — Interactive Behavior

(function() {
  'use strict';

  // --- Reveal on scroll ---
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    revealEls.forEach(el => io.observe(el));
  }

  // --- Accordion ---
  document.querySelectorAll('.accordion-header').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.accordion-item');
      item.classList.toggle('open');
    });
  });

  // --- Gallery thumbs (product page) ---
  const thumbs = document.querySelectorAll('.gallery-thumb');
  const mainImg = document.querySelector('.gallery-main-img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) {
        const bg = thumb.style.background;
        mainImg.style.background = bg;
        mainImg.style.backgroundSize = 'cover';
        mainImg.style.backgroundPosition = 'center';
      }
    });
  });

  // --- Option selection (size, color) ---
  document.querySelectorAll('.option-sizes').forEach(group => {
    group.addEventListener('click', (e) => {
      const target = e.target.closest('.option-size');
      if (!target || target.classList.contains('disabled')) return;
      group.querySelectorAll('.option-size').forEach(s => s.classList.remove('active'));
      target.classList.add('active');
    });
  });

  document.querySelectorAll('.option-swatches').forEach(group => {
    group.addEventListener('click', (e) => {
      const target = e.target.closest('.option-swatch');
      if (!target) return;
      group.querySelectorAll('.option-swatch').forEach(s => s.classList.remove('active'));
      target.classList.add('active');
    });
  });

  // --- Quantity selector ---
  document.querySelectorAll('.qty-selector, .cart-qty').forEach(group => {
    const input = group.querySelector('.qty-input');
    const minus = group.querySelector('.qty-btn.minus');
    const plus = group.querySelector('.qty-btn.plus');
    if (!input) return;
    minus?.addEventListener('click', () => {
      const v = Math.max(1, parseInt(input.value) - 1);
      input.value = v;
    });
    plus?.addEventListener('click', () => {
      input.value = parseInt(input.value) + 1;
    });
  });

  // --- Cart drawer ---
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  const cartTriggers = document.querySelectorAll('[data-open-cart]');
  const cartCloses = document.querySelectorAll('[data-close-cart]');

  function openCart() {
    cartDrawer?.classList.add('open');
    cartOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(t => t.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  }));
  cartCloses.forEach(t => t.addEventListener('click', closeCart));
  cartOverlay?.addEventListener('click', closeCart);

  // --- Toast notification ---
  const toast = document.querySelector('.toast');
  function showToast(message) {
    if (!toast) return;
    toast.querySelector('.toast-text').textContent = message;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 2400);
  }

  // --- Add to cart buttons ---
  document.querySelectorAll('[data-add-cart]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      showToast('Added to your edit');
      // Update cart count
      const counts = document.querySelectorAll('.cart-count');
      counts.forEach(c => {
        c.textContent = parseInt(c.textContent || '0') + 1;
      });
    });
  });

  // --- Wishlist toggle ---
  document.querySelectorAll('.product-wishlist').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      btn.classList.toggle('active');
      showToast(btn.classList.contains('active') ? 'Saved to wishlist' : 'Removed from wishlist');
    });
  });

  // --- Filter pills ---
  document.querySelectorAll('.filter-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      pill.classList.toggle('active');
    });
  });

  // --- Newsletter form ---
  document.querySelectorAll('.newsletter-form').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      showToast('Thank you — first edit unlocked');
      form.reset();
    });
  });

  // --- Smooth header on scroll ---
  let lastScroll = 0;
  const header = document.querySelector('.header');
  window.addEventListener('scroll', () => {
    const current = window.pageYOffset;
    if (current > 80) {
      header?.classList.add('scrolled');
    } else {
      header?.classList.remove('scrolled');
    }
    lastScroll = current;
  });

})();
